export default __webpack_public_path__ + "static/media/btn_filtrer_ouvert.ddeda0b2.svg";